import * as React from "react";
import { MediaQuery, SliderCarousel } from "@grandvisionhq/common";
import { PromotionBanners, HighlightedContent, CategoryLinks, Certificates, RichBanner, PromotionBannersItem, HighlightedContentItem, CategoryLinksItem, CertificatesItem } from "@grandvisionhq/content";
import { Heading, Container } from "@grandvisionhq/elements";
import { FlexLayout } from "@grandvisionhq/layout";
import { compose } from "@grandvisionhq/utils";
import { withBloomreachPageable } from "../../../../hocs/hocs/with-bloomreach-pageable.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
const CmsBannerCollectionItem = withEditableContent(({ content, template }) => {
  const { title, description, content: richText } = content;
  const image = parseBloomreachImage(content.image);
  const links = useBloomreachLinks(content.links);
  const tooltip = content.tooltip?.showTooltip ? content.tooltip : void 0;
  switch (template) {
    case "certificates":
      return /* @__PURE__ */ React.createElement(
        CertificatesItem,
        {
          image: image?.original,
          mobileImage: image?.mobile,
          link: links[0],
          title,
          text: description
        }
      );
    case "main-categories":
      return /* @__PURE__ */ React.createElement(CategoryLinksItem, { image: image?.original, link: links[0], title });
    case "usp":
      return /* @__PURE__ */ React.createElement(
        HighlightedContentItem,
        {
          image: image?.original,
          link: links[0],
          title,
          text: description
        }
      );
    case "promotion-banner":
    case "split-header-promotion":
      return /* @__PURE__ */ React.createElement(
        PromotionBannersItem,
        {
          image: image?.original,
          mobileImage: image?.mobile,
          link: links[0],
          title,
          text: description,
          fullWidth: template === "split-header-promotion",
          tooltip
        }
      );
    case "rich-banner":
      return /* @__PURE__ */ React.createElement(
        RichBanner,
        {
          image: image?.original,
          mobileImage: image?.mobile,
          richText: richText?.value,
          link: links.find((l) => l.style === "image"),
          backgroundColor: "white",
          textColor: "black",
          bannerWidth: "full",
          layout: "collection",
          tooltip
        }
      );
    default:
      return null;
  }
});
const CmsBannerCollection = ({ content, template, meta }) => {
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const items = React.useMemo(
    () => content.items.map((item, i) => /* @__PURE__ */ React.createElement(CmsBannerCollectionItem, { key: `${item.id}-${i}`, content: item, template })),
    [content.items, template]
  );
  switch (template) {
    case "certificates":
      return /* @__PURE__ */ React.createElement(Certificates, null, items);
    case "main-categories":
      return /* @__PURE__ */ React.createElement(CategoryLinks, null, items);
    case "usp":
      return /* @__PURE__ */ React.createElement(HighlightedContent, null, items);
    case "promotion-banner":
    case "split-header-promotion":
      return /* @__PURE__ */ React.createElement(PromotionBanners, { fullWidth: template === "split-header-promotion" }, items);
    case "rich-banner":
      return /* @__PURE__ */ React.createElement(Container, null, isSmallScreen && meta.mobilePresentation === "horizontal" ? /* @__PURE__ */ React.createElement(SliderCarousel, null, items) : /* @__PURE__ */ React.createElement(FlexLayout, { justify: "space-between", wrap: "wrap" }, items));
    default:
      return /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1" }, `Banner collection with template: ${template} is not defined in CmsBannerCollection component.`);
  }
};
const CmsBannerCollection$1 = compose(
  withBloomreachPageable,
  withBreakpointVisibility,
  withAnchor
)(CmsBannerCollection);
export {
  CmsBannerCollection,
  CmsBannerCollectionItem,
  CmsBannerCollection$1 as default
};
//# sourceMappingURL=BannerCollection.js.map
